import classNames from 'classnames/bind';
import React, { forwardRef } from 'react';

import styles from './TypeText.module.scss';

const cx = classNames.bind(styles);

const TypeText = forwardRef(({ className, ...props }, ref) => {
  const handleKeyDown = (e) => {
    if (e.nativeEvent.isComposing) return;

    if (e.code === 'Enter') {
      e.target.blur();
    }

    if (props.onKeyDown) {
      props.onKeyDown(e);
    }
  };

  return <input ref={ref} type="text" {...props} onKeyDown={handleKeyDown} className={cx(['container', className])} />;
});

export default TypeText;
